module.exports = [{
      plugin: require('../../certificacionMontessori/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"kalpilli","short_name":"starter","start_url":"/","background_color":"#663399","display":"minimal-ui","icon":"src/images/lasc.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"07d7b329d12fc7213b5c3714807eb3e1"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../certificacionMontessori/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
